export default "__VITE_ASSET__DqnBV__j__"